import * as v from 'valibot';

export const contractHistoryItemApiSchema = v.object({
  action: v.nullish(v.string()),
  comment: v.nullish(v.string()),
  createdBy: v.nullish(v.number()),
  createdOn: v.nullish(v.string()),
  id: v.nullish(v.string()),
});

export const contractHistorySearchApiSchema = v.object({
  items: v.array(contractHistoryItemApiSchema),
  totalCount: v.number(),
});

export const contractHistoryItemSchema = v.object({
  action: v.string(),
  comment: v.string(),
  createdOn: v.string(),
  id: v.string(),
  userName: v.string(),
});

export const contractHistorySchema = v.object({
  items: v.array(contractHistoryItemSchema),
  totalCount: v.number(),
});

export const contractHistoryParamsSchema = v.object({
  contractKey: v.string(),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  sorting: v.optional(v.string()),
});

export type ContractHistoryItemApi = v.InferOutput<typeof contractHistoryItemApiSchema>;
export type ContractHistorySearchApi = v.InferOutput<typeof contractHistorySearchApiSchema>;
export type ContractHistoryItem = v.InferOutput<typeof contractHistoryItemSchema>;
export type ContractHistory = v.InferOutput<typeof contractHistorySchema>;
export type ContractHistoryParams = v.InferOutput<typeof contractHistoryParamsSchema>;
